import { I18n } from '@calendly/i18n';
import { Avatar } from '@calendly/ui/components/avatar';
import { FullStoryExclude, FullStoryMask } from '@calendly/ui/components/fullstory-privacy';
import { Item } from '@calendly/ui/components/menu';
import classNames from 'classnames';
import { forwardRef } from 'react';
const markerCss = "m10rm12m";
const Marker = forwardRef((props, ref) => {
  const size = 'tiny';
  const letter = ' ';
  return <FullStoryExclude>
      <Avatar ref={ref} {...props} size={size} letter={letter} className={classNames(markerCss, props.className)} />
    </FullStoryExclude>;
});
const AllScope = ({
  scope,
  onClick,
  title
}) => {
  const name = {
    all_users: I18n.t('publisher.title.all_users'),
    all_teams: I18n.t('publisher.title.all_teams'),
    all_users_and_teams: I18n.t('publisher.title.all_users_and_teams')
  }[scope];
  return <Item onClick={onClick}>
      <Marker />
      <FullStoryMask>{title || name}</FullStoryMask>
    </Item>;
};
export default AllScope;

require("./all_scope.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./all_scope.js");